const buildPrices = (perLiter) => ({
  '20L': Number((perLiter * 20).toFixed(2)),
  '30L': Number((perLiter * 30).toFixed(2)),
  '50L': Number((perLiter * 50).toFixed(2)),
  perLiter: Number(perLiter.toFixed(2)),
});

export const catalogProducts = [
  {
    id: 'ashby-pilsen',
    brand: 'Ashby',
    category: 'pilsen',
    name: 'Chopp Ashby Pilsen',
    style: 'Pilsen',
    description:
      'Referência em qualidade artesanal, o Chopp Ashby Pilsen é puro malte e entrega coloração dourada, espuma cremosa e equilíbrio elegante entre malte e refrescância.',
    prices: buildPrices(12.9),
    image: '/catalogo/Barril Ashby.png',
    abv: 4.6,
    ibu: 12,
  },
  {
    id: 'stell-pilsen',
    brand: 'Stell',
    category: 'pilsen',
    name: 'Chopp Stell Pilsen',
    style: 'Pilsen',
    description:
      'Pureza, leveza e excelente drinkability definem o Chopp Stell Pilsen, com perfil limpo, refrescante e ideal para churrascos, festas e confraternizações.',
    prices: buildPrices(12.9),
    image: '/catalogo/Barril Stell.png',
    abv: 4.3,
    ibu: 8,
  },
  {
    id: 'hockenheim-pilsen',
    brand: 'Hockenheim',
    category: 'pilsen',
    name: 'Chopp Hockenheim Pilsen',
    style: 'Pilsen',
    description:
      'Chopp leve, refrescante e versátil, com perfil equilibrado para servir bem em eventos, aniversários e encontros em casa.',
    prices: buildPrices(12.9),
    image: '/catalogo/Barril Hockenheim.png',
    abv: 4.5,
    ibu: 9,
  },
  {
    id: 'hockenheim-pilsen-puro-malte',
    brand: 'Hockenheim',
    category: 'pilsen',
    name: 'Chopp Hockenheim Pilsen Puro Malte',
    style: 'Pilsen Puro Malte',
    description:
      'Versão puro malte da Hockenheim, com corpo mais presente, excelente formação de espuma e final limpo para quem busca uma experiência mais premium.',
    prices: buildPrices(14.9),
    image: '/catalogo/Pilzen Puro Malte Barril.png',
    abv: 4.8,
    ibu: 17,
  },
  {
    id: 'ashby-nirvana-ipa',
    brand: 'Ashby',
    category: 'ipa',
    name: 'Chopp Ashby IPA Nirvana',
    style: 'Nirvana IPA',
    description:
      'Ashby IPA Nirvana, uma expoente do estilo India Pale Ale que traz 4 lúpulos em sua receita e o processo de dry hopping, sendo amarga e aromática no ponto certo. Preparada seguindo as tradições inglesas para esse estil mais que apaixonante. Um cerveja ideal para os apreciadores de cervejas mais amargas e complexas.',
    prices: buildPrices(17.9),
    image: '/catalogo/Barril Ashby.png',
    abv: 5.5,
    ibu: 55,
  },
  {
    id: 'stell-ipa',
    brand: 'Stell',
    category: 'ipa',
    name: 'Chopp Stell IPA',
    style: 'New England IPA',
    description:
      'Uma IPA aromática e sedosa, com foco nos lúpulos e excelente drinkability para quem gosta de intensidade com suavidade no gole.',
    prices: buildPrices(17.9),
    image: '/catalogo/Barril Stell.png',
    abv: null,
    ibu: null,
  },
  {
    id: 'hockenheim-rota-77-american-ipa',
    brand: 'Hockenheim',
    category: 'ipa',
    name: 'Chopp Hockenheim Rota 77',
    style: 'American IPA',
    description:
      'Apresenta aroma e sabor bem-marcados pelos fortes lúpulos americanos, que nos trazem uma percepção sensorial de florais, cítricas, de pinho, frutas tropicais e vermelhas. Seca, refrescante e de corpo leve, uma American IPA de percepção de álcool suave e leve aquecimento.',
    prices: buildPrices(17.9),
    image: '/catalogo/Rota 77 IPA barril.png',
    abv: 7.4,
    ibu: 73,
  },
  {
    id: 'ashby-vinho',
    brand: 'Ashby',
    category: 'vinho',
    name: 'Chopp Ashby de Vinho',
    style: 'Draft Wine',
    description:
      'Uma experiência diferenciada que une refrescância e perfil frutado, criando uma opção marcante para eventos especiais.',
    prices: buildPrices(17.9),
    image: '/catalogo/Barril Ashby.png',
    abv: null,
    ibu: null,
  },
  {
    id: 'stell-vinho',
    brand: 'Stell',
    category: 'vinho',
    name: 'Chopp Stell de Vinho',
    style: 'Gourmet Wine Beer',
    description:
      'Uma proposta sofisticada, com notas frutadas e perfil refrescante para quem quer fugir do comum em celebrações e confraternizações.',
    prices: buildPrices(17.9),
    image: '/catalogo/Barril Stell.png',
    abv: null,
    ibu: null,
  },
  {
    id: 'hockenheim-vinho',
    brand: 'Hockenheim',
    category: 'vinho',
    name: 'Chopp Hockenheim de Vinho',
    style: 'Chopp de Vinho',
    description:
      'Opção frutada, refrescante e de excelente aceitação, ideal para quem procura uma bebida diferenciada e muito agradável para servir.',
    prices: buildPrices(17.9),
    image: '/catalogo/Barril Hockenheim.png',
    abv: 6.0,
    ibu: 15,
  },
];
